
import customQueryPreviewHtml from './customQueryPreview.html';

class customQueryPreviewController {
    constructor($timeout, $sce, $element) {
        'ngInject';
        this.$sce = $sce;
        this.$timeout = $timeout;
        this.$element = $element;
    }

    get svgString() {
        return this.$sce.trustAsHtml(this.adminProductionFile && this.model.adminProductionFile ? this.model.adminProductionFile : this.model.productionFile);
    }

    $postLink() {

        this.$timeout(() =>  {
            let svgWidth = this.width || 400;
            let svgHeight = this.height;
            let padding = this.padding || 50;
            let svgCont = this.$element;
            let preview = svgCont.find('svg');

            preview.css('width', svgWidth+'px');
            preview.css('height', svgHeight ? svgHeight+'px' : 'auto');
            preview.css('background', '#F5F5F5');

            preview.find('defs').remove();
            preview.find('*')
                .attr('class', null)
                .attr('fill', '#FFF')
                .attr('stroke', '#575757')
                .attr('stroke-width', '0.5')
                .attr('vector-effect', "non-scaling-stroke")
                .attr('shape-rendering', 'geometricprecision');
            let orgViewbox = preview[0].getAttribute('viewBox').split(' ');
            let newViewBox =  -(parseInt(orgViewbox[2]*0.01)) + ' ' + (-parseInt(orgViewbox[3]*0.01)) + ' ' + (parseInt(orgViewbox[2]*1.02)) + ' ' + (parseInt(orgViewbox[3]*1.02));
            preview[0].setAttribute('viewBox', newViewBox);

            svgCont.css('padding', padding+'px');

            if (this.dimm) {
                    let width = this.model.data && this.model.data.width || this.model.width;
                    let height = this.model.data && this.model.data.height || this.model.height
                    let xLineDesc = $('<span style="color: #F5821F;text-align: center;display: inline-block;margin-top: 5px;font-size: 11px;"/>').text( width + ' mm');
                    let yLineDesc = $('<span style="color: #F5821F;text-align: center;display: inline-block;font-size: 11px;transform: rotate(270deg);width: 100px;margin-left: -65px; position:absolute"/>').css('top', (preview.height()/2 - 10) + 'px').text(height + ' mm');
                    let yLine = $('<div style="text-align:center; position: absolute; border: 1px solid red; border-right:none; width: 5px;position: absolute;top: 50px;left: 20px;">').css('height', preview.height()+'px');
                    let xLine = $('<div style="text-align:center; position: absolute; border: 1px solid red; border-top:none; height: 5px;position: absolute;bottom: 30px;left: 20px;">').css('width', preview.width()+'px').css('left', 50 + 'px');

                    svgCont.append(yLine).append(xLine);
                    yLine.append(yLineDesc);
                    xLine.append(xLineDesc);
            }
        });
    }
}

let customQueryPreviewComponent = {
    bindings: {
        'model': '<',
        'width': '<',
        'height': '<',
        'dimm': '<',
        'padding': '<',
        'adminProductionFile': '<'
    },
    template: customQueryPreviewHtml,
    controller: customQueryPreviewController
};

export default customQueryPreviewComponent;
